import en from './en';

// German translations. The English resource is spread first so newly added
// keys remain available until their localized copy is introduced.
export default {
  ...en,
  hello: 'Hallo!',
  delete: 'Löschen',
  edit: 'Bearbeiten',
  search: 'Suchen',
  confirm: 'Bestätigen',
  cancel: 'Abbrechen',
  next: 'Weiter',
  save: 'Speichern',
  yes: 'Ja',
  no: 'Nein',
  enter: 'Eingeben',
  input: 'Eingabe',
  select: 'Auswählen',
  basic_information: 'Grundinformationen',
  additional_information: 'Zusätzliche Informationen',
  knowledge_base: 'Wissensdatenbank',
  template: 'Template',
  machine: 'Maschine',
  issues: 'Probleme',
  causes: 'Ursachen',
  routines: 'Routinen',
  tag: 'Tag',
  manufacturer: 'Hersteller',
  location: 'Standort',
  serial_number: 'Seriennummer',
  construction_date: 'Baudatum',
  acceptance_date: 'Abnahmedatum',
  description: 'Beschreibung',
  status: 'Status',
  action: 'Vorgang',
  active: 'Aktiv',
  deactivated: 'Deaktiviert',
  dashboard_welcome: 'Was möchten Sie heute lösen?',
  dashboard_dignose: 'Diagnose',
  dashboard_knowledge_base: 'Wissensdatenbank',
  dashboard_analyse: 'Insights',
  template_add_new: 'Neue Template hinzufügen',
  machine_add_new: 'Neue Maschine hinzufügen',
  machine_all_machines: 'Alle Maschinen',
  machine_name: 'Maschinenname',
  unique_id: 'Eindeutige ID',
  machine_type: 'Maschinentyp',
  template_information: 'Templateninformationen',
  template_type: 'Templatentyp',
  template_name: 'Templatenname',
  password: 'Passwort',
  current_password: 'Aktuelles Passwort',
  new_password: 'Neues Passwort',
  confirm_password: 'Passwort bestätigen',
  change_password: 'Passwort ändern',
  log_out: 'Abmelden',
  user_management: 'Benutzerverwaltung',
  client_management: 'Kundenverwaltung',
  first_name: 'Vorname',
  last_name: 'Nachname',
  full_name: 'Vor und Nachname',
  role: 'Rolle',
  company: 'Firma',
  company_name: 'Firmenname',
  address: 'Adresse',
  contact: 'Kontaktdaten',
  license_status: 'Lizenzstatus',
  preview: 'Vorschau',
  resource_library: 'Ressourcenbibliothek',
  files: 'Dateien',
  image_gallery: 'Bildergalerie',
  machine_images: 'Maschinenbilder',
  issue_images: 'Problembilder',
  cause_images: 'Ursachenbilder',
  no_images: 'Keine Bilder',
  copy_link: 'Link kopieren',
  link_causes: 'Ursache(n) verknüpfen',
  link_machines: 'Maschine(n) verknüpfen',
  search_for_machine: 'Maschine suchen',
  search_for_issue: 'Problem suchen',
  no_machines: 'Keine Maschinen',
  no_issues: 'Keine Probleme',
  possible_causes: 'Mögliche Ursachen',
  identified_causes: 'Erkannte Ursachen',
  no_description: 'Keine Beschreibung.',
  details: 'Details',
  solution_grid: 'Solution Grid',
  issue: 'Probleme',
  cause: 'Ursachen',
  routine: 'Routinen',
  notifications: 'Benachrichtigungen',
  show_more: 'Mehr anzeigen',
  show_less: 'Weniger anzeigen',
  password_mismatch: 'Die Passwörter stimmen nicht überein!',
  password_changed: 'Passwort erfolgreich geändert!',
  login_failed: 'Anmeldung fehlgeschlagen, bitte versuchen Sie es erneut.',
  enter_email: 'E-Mail-Adresse eingeben',
  enter_password: 'Passwort eingeben',
  enter_new_password: 'Neues Passwort eingeben',
  enter_current_password: 'Aktuelles Passwort eingeben',
  select_date: 'Datum auswählen',
  required_email: 'Bitte geben Sie eine E-Mail-Adresse ein!',
  required_password: 'Bitte geben Sie ein Passwort ein!',
  required_current_password: 'Bitte geben Sie das aktuelle Passwort ein!',
  required_confirm_password: 'Bitte bestätigen Sie das Passwort!',
  required_first_name: 'Bitte geben Sie den Vornamen ein!',
  required_last_name: 'Bitte geben Sie den Nachnamen ein!',
  required_role: 'Bitte wählen Sie eine Rolle aus!',
  required_company: 'Bitte wählen Sie ein Unternehmen aus!',
  required_status: 'Bitte wählen Sie den Status aus!',
  required_machine_name: 'Bitte geben Sie den Maschinennamen ein!',
  required_description: 'Bitte geben Sie eine Beschreibung ein!',
  machine_created: 'Maschine erfolgreich erstellt!',
  machine_updated: 'Maschine erfolgreich aktualisiert!',
  routine_created: 'Neue Routine erstellt!',
  routine_updated: 'Routine aktualisiert!',
  suggestion_submitted: 'Vorschlag übermittelt',
  deleting: 'Wird gelöscht ...',
  suggest_routine: 'Vorgeschlagene Routinen',
  diagnose_issue: 'Maschinenliste',
  flow_coming_soon: 'Ablauf (Bald verfügbar)',
  diagnose_coming_soon: 'Diagnose (Bald verfügbar)',
  people_coming_soon: 'Personen (Bald verfügbar)',
  skillset_coming_soon: 'Fähigkeiten (Bald verfügbar)',
  welcome_to_solvv: 'Willkommen bei SolvV',
  remember_me: 'Angemeldet bleiben',
  sign_in: 'Anmelden',
  select_company: 'Unternehmen auswählen',
  routine_name: 'Routinename',
  need_assistance: 'Benötigen Sie Hilfe?',
  call_machine_builder: 'Maschinenhersteller kontaktieren',
  create_ticket: 'Ticket erstellen',
  copy: 'Kopieren',
  stay_here: 'Hier bleiben',
  back: 'Zurück',
  language: 'Sprache',
  english: 'Englisch',
  german: 'Deutsch',
  next_issue: 'Weiter',
  no_matching_issue:
    'Leider gibt es kein passendes Problem für das hochgeladene Foto.',
  edit_versions: 'Versionen bearbeiten',
  version_info: 'Versionsinformationen',
  version_name: 'Versionsname',
  input_version_name: 'Bitte geben Sie den Versionsnamen ein',
  input_description: 'Bitte geben Sie eine Beschreibung ein',
  unsaved_changes: 'Achtung! Sie haben ungespeicherte Änderungen',
  leave_anyway: 'Trotzdem verlassen',
  routine_repair_exit: 'Sie verlassen den Reparaturablauf.',
  page_title: 'SolvV',
  type: 'Typ',
  batchUpload: 'Stapel-Upload',
  save_as_draft: 'Als Entwurf speichern',
  dignose: 'Diagnose',
  analyse: 'Analyse',
  flow: 'Ablauf (Bald verfügbar)',
  menu_diagnose: 'Diagnose',
  menu_knowledge_base: 'Wissensdatenbank',
  menu_insights: 'Insights',
  knowledge_base_suggestion_view: 'Überprüfung von Benutzervorschlägen',
  template_existing: 'Vorhandene Templaten',
  flow_add_new: 'Neuen Ablauf hinzufügen',
  flow_existing: 'Vorhandene Abläufe',
  machine_existing: 'Vorhandene Maschinen',
  alias: 'Alias',
  service_number: 'Servicenummer',
  email: 'Email',
  initial_password: 'Anfangspasswort',
  add_new_user: 'Neue User hinzufügen',
  edit_user: 'Benutzer „{{name}}“ bearbeiten',
  add_new_client: 'Neuen Kunden hinzufügen',
  edit_client: 'Kunden „{{name}}“ bearbeiten',
  no_possible_causes: 'Keine möglichen Ursachen',
  heatmap: 'Heatmap',
  issues_to_be_reviewed: 'Probleme (zu überprüfen)',
  causes_to_be_reviewed: 'Ursachen (zu überprüfen)',
  routines_to_be_reviewed: 'Routinen (zu überprüfen)',
  delete_failed: 'Löschen fehlgeschlagen!',
  submit_failed: 'Übermittlung fehlgeschlagen!',
  submit_failed_try_again:
    'Übermittlung fehlgeschlagen, bitte versuchen Sie es erneut!',
  load_images_failed: 'Laden der Bilder fehlgeschlagen!',
  upload_failed: 'Upload fehlgeschlagen!',
  upload_image_type_error: 'Sie können nur JPG-/PNG-/BMP-Dateien hochladen!',
  upload_image_size_error: 'Das Bild muss kleiner als 2 MB sein!',
  enter_routine_name: 'Routinennamen eingeben',
  enter_routine_description: 'Routinenbeschreibung eingeben ...',
  required_cause_name: 'Bitte geben Sie den Ursachennamen ein!',
  required_issue_name: 'Bitte geben Sie den Problemnamen ein!',
  required_routine_name: 'Bitte geben Sie den Routinenamen ein!',
  diagnosis_insight_coming_soon: 'Diagnose-Einblicke (Bald verfügbar)',
  people_reserve_coming_soon: 'Personenbereich (Bald verfügbar)',
  skillset_reserve_coming_soon: 'Fähigkeitsbereich (Bald verfügbar)',
  required_company_name: 'Bitte geben Sie den Unternehmensnamen ein!',
  required_company_type: 'Bitte wählen Sie den Unternehmenstyp aus!',
  required_email_lowercase: 'Bitte geben Sie eine E-Mail-Adresse ein!',
  complete_form: 'Bitte füllen Sie das Formular korrekt aus.',
  submit_failed_short: 'Übermittlung fehlgeschlagen.',
  fill_user_information:
    'Bitte füllen Sie die Benutzerinformationen aus, um fortzufahren.',
  fill_company_information:
    'Bitte füllen Sie die Unternehmensinformationen aus, um fortzufahren.',
  images_uploading:
    'Bild(er) werden hochgeladen. Bitte übermitteln Sie sie nach Abschluss!',
  operation_and_safety_precautions: 'Betriebs- und Sicherheitsvorkehrungen',
  delete_machine: '„{{name}}“ löschen',
  confirm_delete_machine: 'Möchten Sie {{name}} wirklich löschen?',
  template_copied: 'Template erfolgreich kopiert!',
  go_to_copied_template: 'Zur kopierten Template wechseln?',
  copy_failed: 'Kopieren fehlgeschlagen!',
  delete_failed_capitalized: 'Löschen fehlgeschlagen!',
  delete_template: '„{{name}}“ löschen',
  confirm_delete_template: 'Möchten Sie {{name}} wirklich löschen?',
  select_safety_instructions: 'Sicherheitsanweisungen auswählen',
  unlink_cause_confirmation: 'Möchten Sie diese Ursache wirklich entfernen?',
  remove_step_confirmation: 'Möchten Sie diesen Schritt wirklich entfernen?',
  add_new_step: 'Neue Steps hinzufügen',
  image: 'Bild',
  name: 'Name',
  enter_step_description: 'Schrittbeschreibung eingeben ...',
  select_frequency: 'Häufigkeit auswählen',
  download_company_logs: 'Unternehmensprotokolle herunterladen',
  select_a_company: 'Unternehmen auswählen',
  log_file: 'Protokolldatei',
  select_a_log_file: 'Protokolldatei auswählen',
  no_permission: 'Sie haben leider keine Berechtigung für diese Seite!',
  password_reset_success: 'Passwort erfolgreich zurückgesetzt!',
  reset_password_login_again:
    'Benutzerinformationen fehlen. Bitte melden Sie sich erneut an.',
  previous: 'Zurück',
  search_for: 'Suchen nach {{value}}',
  submitted_by: 'Eingereicht von:',
  at: 'um',
  approved_reason: 'Genehmigungsgrund',
  rejected_reason: 'Ablehnungsgrund',
  reject: 'Ablehnen',
  accept_and_save: 'Annehmen und Speichern',
  production: 'Produktion',
  trial: 'Testversion',
  coming_soon: 'Bald verfügbar!',
  go_back: 'Zurück',
  upload: 'Hochladen',
  file_upload_success: 'Datei erfolgreich {{action}}!',
  file_upload_failed: 'Datei-{{action}} fehlgeschlagen!',
  could_not_preview_image: 'Dieses Bild konnte nicht angezeigt werden.',
  no_preview_available: 'Für diese Datei ist keine Vorschau verfügbar.',
  delete_file_confirmation: 'Möchten Sie {{name}} wirklich löschen?',
  suggest_an_issue: 'Problem vorschlagen',
  suggest_a_cause: 'Ursache vorschlagen',
  suggest_a_routine: 'Routine vorschlagen',
  suggested_issue: 'Vorgeschlagene Probleme',
  suggested_cause: 'Suggested Ursache',
  suggested_routine: 'Suggested Routine',
  qualification: 'Qualifikation',
  labels: 'Labels',
  tools: 'Tools',
  link_cause_hint: 'Cause wählen und zu der Routine verlinken',
  click_to_upload_image: 'hochladen',
  identify_cause_hint:
    'Nutzen Sie den untenstehenden Prozess um Causes zu identifizieren',
  diagnose_done_message:
    'Fertig! Sieh dir das Ergebnis auf der rechten Seite an!',
  repair_routine: 'Reparaturroutine',
  routine_completed: 'Routine erledigt.',
  duration: 'Dauer',
  is_issue_resolved: 'Probleme gelöst?',
  no_back_to_diagnosis: 'No, Back To DiagnosiZurück zu',
  no_need_help: 'Ich brauche Hilfe',
  link_machine: 'Maschinen verlinken',
  select_machine_hint: 'Maschine(n) wählen und zu dem Template verlinken',
  current_label: 'Aktuell ({{count}})',
  to_be_reviewed_label: 'Zur Überprüfung ({{count}})',
  rejected_label: 'Abgelehnt ({{count}})',
  linked_in_solution_grid: 'Im Lösungsraster verknüpft',
  add_new_cause: 'Neue Ursache hinzufügen',
  add_new_routine: 'Neue Routine hinzufügen',
  add_new_issue: 'Neues Problem hinzufügen',
  add_issue: 'Problem hinzufügen',
  save_as_new_version: 'Als neue Version speichern',
  remove: 'Entfernen',
  find_other_solution: ' Andere Lösung finden?',
  observe_other_issue: 'Anderes Problem beobachten?',
  compare_reason: 'Grund für das gesuchte Bild vergleichen:',
  description_for_issues_image: 'Beschreibung der Bilder des Problems:',
  selected: 'Ausgewählt',
  matched: 'Übereinstimmend',
  not_right_cause: 'Nicht die richtige Ursache',
  close_without_cause: 'Ohne Ursache schließen',
  found_the_right_cause: 'Die richtige Ursache gefunden',
  yes_go_to_routine: 'Ja, zur Routine',
};
